import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IHeaderProps {
  background: string;
}

export const ModalDialogOverlay = styled.div`
  background: rgba(0, 0, 0, 0.55);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
`

export const ModalDialogContent = styled.div`
  width: 100%;
  max-width: 90%;
  max-height: 90vh;

  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 999;
  overflow: auto;

  background: #fff;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, .08);

  @media (min-width: ${customTheme.breakpoints[0]}) {
    max-width: 480px;
  }
  @media (min-width: ${customTheme.breakpoints[1]}) {
    max-width: 700px;
  }
  @media (min-width: ${customTheme.breakpoints[2]}) {
    max-width: 870px;
  }
  @media (min-width: ${customTheme.breakpoints[3]}) {
    max-width: 870px;
  }
`

export const ModalDialogHeader = styled.div<IHeaderProps>`
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;


  background-color: ${({ background }) => background};
`

export const ModalDialogHeaderTitle = styled.h3`
  margin: 0;
  padding: 0;

  font-size: 18px;
  line-height: 22px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  color: #000;
`

export const ModalDialogClose = styled.div`
  margin-left: auto;
  width: 30px;

  position: absolute;
  right: 5px;
  top: 5px;

  font-size: 25px;
  text-align: center;
  background: none;
  color: ${customTheme.colors.black};
  cursor: pointer;
`

export const ModalDialogBody = styled.div`
  max-height: 85%;
  padding: 30px;
  overflow-y: auto;
  
  & {
  scrollbar-width: thin;
  scrollbar-color: ${customTheme.colors.gray['500']} transparent;
  }

  &::-webkit-scrollbar {
    width: 10px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
  background-color: ${customTheme.colors.gray['500']};
  border-radius: 20px;
  border: 3px solid transparent;
  }

  button {
    width: 100%;
    border-radius: 50px;
    cursor: pointer;
    background: rgb(90,255,90);
    background: linear-gradient(180deg, rgba(90,255,90,1) 40%, rgba(112,238,112,1) 76%, rgba(82,200,82,1) 100%);
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
    border: 2px solid #000;
    padding: 10px 0;
  }
`

export const ModalDialogFooter = styled.div``
